import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { CustomButton } from 'src/components/ui'
import { useGetTypeOfBottleFromUrl } from 'src/hooks'
import { useCreateBottle } from 'src/zustand/stores/createBottle.store'

import styles from '../InputNameOfBottle/InputNameOfBottle.module.scss'
import { dateDaysDifference } from '../utils/dateDaysDifference'
import { isValidDate } from '../utils/isValidDate'

const InputDateOfBottle = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const addBottleDate = useCreateBottle((state) => state.addBottleDate)
  const bottleDate = useCreateBottle((state) => state.bottleDate)

  const [dateFrom, setDateFrom] = React.useState<string>(bottleDate.from)
  const [dateTo, setDateTo] = React.useState<string>(bottleDate.to)

  const typeOfBottle = useGetTypeOfBottleFromUrl()

  const daysDifference = dateDaysDifference(dateFrom, dateTo)
  const buttonValidate =
    dateFrom.length === 10 &&
    dateTo.length === 10 &&
    isValidDate(dateFrom) &&
    isValidDate(dateTo) &&
    daysDifference >= 0

  const handleDateSetting = () => {
    addBottleDate([dateFrom, dateTo])
    if (!isValidDate(dateFrom) || !isValidDate(dateTo)) {
      navigate('/create-bottle/error')
      return
    }

    if (daysDifference > 90 || daysDifference < 0) {
      navigate('/create-bottle/error')
      return
    }

    navigate(`/create-bottle/confirmation?type=${typeOfBottle}`)
  }

  const isNotOpenOnPhone = ['macos', 'windows', 'linux', 'web'].includes(window.Telegram.WebApp.platform)

  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapper_input}>
        <label htmlFor='input'>
          {t('create_bottle.input_availability_period')} <br />
          {t('create_bottle.three_months_maximum')}
        </label>

        <div className={styles.input_date}>
          <div className={styles.paragraphs}>
            <p className={styles['input_date-from']}>{t('create_bottle.from')}</p>
            <p>{t('create_bottle.to')}</p>
          </div>

          <div>
            <input
              type='date'
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
              className={!dateFrom && !isNotOpenOnPhone ? styles.empty : ''}
              lang='en'
            />
            <input
              type='date'
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
              className={!dateTo && !isNotOpenOnPhone ? styles.empty : ''}
              lang='en'
            />
          </div>
        </div>
      </div>

      <div className={styles.tabs}>
        <CustomButton
          onClick={handleDateSetting}
          variant={buttonValidate ? 'contained' : 'not-active'}
          color='white'
          className={styles.button}
        >
          {t('create_bottle.set_date')}
        </CustomButton>
      </div>
    </div>
  )
}

export default InputDateOfBottle
